import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 详情
export function detail(requestBody) {
  return request({
    url: URL.finance.statementElementDescription.detail,
    method: 'post',
    data: requestBody
  })
}

// 保存
export function save(requestBody) {
  return request({
    url: URL.finance.statementElementDescription.save,
    method: 'post',
    data: requestBody
  })
}

// 新增明细科目
export function saveList(requestBody) {
  return request({
    url: URL.finance.statementElementDescription.saveList,
    method: 'post',
    data: requestBody
  })
}
